export default "__VITE_ASSET__BPBwh43q__"